'use client';

import React from 'react';
import { useContext } from '~/lib/react';

type OverlayContextValue = {
  mount(id: string, element: React.ReactNode): void;
  unmount(id: string): void;
};

const OverlayContext = React.createContext<OverlayContextValue | null>(null);
export const useOverlayContext = () => useContext(OverlayContext);

export const OverlayProvider = ({ children }: React.PropsWithChildren<unknown>) => {
  /** overlay 들을 관리하는 상태 */
  const [overlayById, setOverlayById] = React.useState<Map<string, React.ReactNode>>(new Map());

  /** overlay 요소를 상태에 추가한다. */
  const mount = React.useCallback((id: string, overlay: React.ReactNode) => {
    setOverlayById((overlayById) => {
      const newOverlayById = new Map(overlayById);

      newOverlayById.set(id, overlay);

      return newOverlayById;
    });
  }, []);

  /** overlay 요소를 상태에서 제거한다. */
  const unmount = React.useCallback((id: string) => {
    setOverlayById((overlayById) => {
      const newOverlayById = new Map(overlayById);

      newOverlayById.delete(id);

      return newOverlayById;
    });
  }, []);

  const context = React.useMemo(() => ({ mount, unmount }), [mount, unmount]);

  return (
    <OverlayContext.Provider value={context}>
      {children}

      {[...overlayById.entries()].map(([id, overlay]) => {
        return <React.Fragment key={id}>{overlay}</React.Fragment>;
      })}
    </OverlayContext.Provider>
  );
};
